import React from 'react'

import ReactMarkdown from 'react-markdown'
import MarkdownHelper from '../../utils/MarkdownHelper'

import Offer from './Offer'
import ViewToggle from '../../subcomponents/ViewToggle'
import { FootnotesFromContext } from "../../subcomponents/Footnotes";

const Hub = props => {
    return (
        <div className="mam3-type offer-hub border">
            <div className="placeholder-image">
                {props.placeholderImage
                    ? <img src={props.placeholderImage} className="img-fluid" alt="Placeholder" />
                    : null
                }
            </div>

            <div className="hub">
                <div className="controls">
                    <button className="prev"></button>
                    <button className="next"></button>
                </div>

                <div className="indicators">
                    <div className="indicator"></div>
                    <div className="indicator active"></div>
                    <div className="indicator"></div>
                    <div className="indicator"></div>
                    <div className="indicator"></div>
                </div>

                <Offer className="promo" {...props} campaign={props.campaign} image={props.campaign.image_16_9} />
            </div>

            <div className="placeholder-text">
                <ReactMarkdown {...MarkdownHelper.allTypes()} source={
                    `__${props.campaign.heading_offer_hub || 'Attraktive Prämien und emotionale Erlebniswelten'}__ 
                   ${props.campaign.sub_heading_offer_hub || 'Entdecken Sie die wunderbare Welt der Meilen'}`} />
            </div>
        </div>
    )
}

const OfferHub = props => {
    return (
        <ViewToggle isMobile={props.isMobile('web')}>
            <Hub {...props} campaign={props.campaign} placeholderImage={props.isMobile('web') ?
                props.campaign.offer_hub_hintergrundbild_mobile_16_9 :
                props.campaign.offer_hub_hintergrundbild_desktop} />
            <FootnotesFromContext
                showWarningText={props.footnotesWarningText}
                bigIndices={props.bigIndices}
            />
        </ViewToggle>
    )

}

export default OfferHub



// WEBPACK FOOTER //
// ./src/components/ads/mam3/OfferHub.js